const info = {
  offerId: "1450019044",
  groupid: "TASK201105202856632",
  maps: [
    {
      level: "junior",
      task_id: "15263150abe35ec1"
    },
    {
      level: "senior",
      task_id: "7d5e5ce6aa8c06f2"
    }
  ],
  end_time: "2020/11/31 23:59:59",
  openlink: "https://pay.qq.com/h5/store/apple-gift-card.shtml?pf=__mds_wx_appstore",
  shareInfo: {
    DESC: "集合！全网寻找最强合伙人，一起冲击最高成团礼包吧！",
    ICON: "https://midas.gtimg.cn/store_config/1585207867985EI153zif.png",
    MINIPROGRAM_ICON: "//midas.gtimg.cn/store_config/15856368586583jXolNnj.jpg",
    INGAME_BASE64_ICON:
      "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",
    TITLE: "分销活动首页",
    URL: "https://pay.qq.com/views/wzry-20201111/wzry-20201111.shtml",
    INGAME_PIC: "//midas.gtimg.cn/store_config/1605008180292zUbR7Zf.png",
    H5_PIC: "//midas.gtimg.cn/store_config/1605008157479MaZYRGKT.png"
  },
  products: [
    {
      name: "红蓝对决1日",
      product_id: "1450019044_EMPTY_1",
      btn_text: "20点券/红蓝对决1日<br/><span class='text-mini'>（赠1步）</span>",
      score: 1,
      price: "20",
      buy_limits_score: "1800",
      groupid: "GOODS201118235841838"
    },
    {
      name: "红蓝对决1日(6个)",
      btn_text: "114点券/红蓝对决1日*6<br/><span class='text-mini'>（赠6步+1步）</span>",
      product_id: "1450019044_EMPTY_6",
      score: 6,
      price: "114",
      groupid: "GOODS201118235841838",
      buy_limits_score: "1795"
    },
    {
      name: "酷炫机甲1日",
      product_id: "1450019044_EMPTY_500",
      btn_text: "50点券/酷炫机甲1日<br/><span class='text-mini'>（赠1步）</span>",
      score: 1,
      price: "50",
      groupid: "GOODS201106152223406",
      buy_limits_score: "1800"
    },
    {
      name: "酷炫机甲1日(6个)",
      product_id: "1450019044_EMPTY_2850",
      btn_text: "285点券/酷炫机甲1日*6<br><span class='text-mini'>（赠6步+1步）</span>",
      score: 6,
      price: "285",
      groupid: "GOODS201106152223406",
      buy_limits_score: "1795"
    }
  ],
  rules: `

<p>活动时间：2020.11.11～2020.11.20</p>

<p>活动怎么玩：</p>     <ol>
<li>1、进入活动页需先<span style="font-weight: bold">绑定游戏角色</span>，活动期间不可再修改；</li>
<li>2、棋盘每一圈从起点到终点需要一共需要走7步，每一步对应一个100%中奖的宝箱，玩家最多可玩<span style="font-weight: bold">300圈</span>；</li>
<li>3、玩家在初阶地图每付费购买一次红蓝对决1日*1，可获赠一次开箱机会，并可往前跳1步，购买一次红蓝对决1日*6，则可获得6连抽机会，并直接赠送第七步【终极孤单宝箱】的开箱机会；在进阶地图每付费购买一次酷炫机甲1日*1，可获赠一次开箱机会，并可往前跳1步，购买一次酷炫机甲1日*6，则可获得6连抽机会，并直接赠送第七步【终极孤单宝箱】的开箱机会，系统<span style="font-weight: bold">自动开启</span>宝箱抽取好礼。如遇网络拥堵自动开宝箱失败，可点击宝箱弹窗内的按钮手动开宝箱，或者直接点击页面宝箱开启；</li>
<li>4、每一圈的第7步为赠送宝箱，需要玩家<span style="font-weight: bold">手动开启</span>，开宝箱机会在跳至第6步时<span style="font-weight: bold">自动赠送</span>，有机会开出<span style="font-weight: bold">传说皮肤</span>；</li>
<li>5、<span style="font-weight: bold">点击宝箱图标</span>，可以查看宝箱内奖品信息以及查看该宝箱内的中奖记录，每个宝箱相互独立，需要分别查看奖池明细和中奖记录</li>
<li>6、红蓝对决、酷炫机甲及宝箱中开出的奖品，获得后将<span style="font-weight: bold">立即发货</span>至游戏内邮箱中，如遇网络拥堵可能略有延迟请耐心等待～</li>     </ol>


<p style="margin-top:10px;">初阶地图活动宝箱中奖品概率公示：</p>     <ol>
<li>每一圈第1、2步【好运到宝箱】——皮肤碎片*2（48.80%）、荣耀积分*20(28.60%) 、缤纷独角兽(0.30 %)、白执事(0.40%)、森(0.60%)、新品皮肤抽奖券*1(21.30%)</li>
<li>每一圈第3、4步【福气到宝箱】——皮肤碎片*2(48.80%)、荣耀积分*20(28.60%)、缤纷独角兽(0.15%)、晚萤(0.15%)、白执事(0.2%)、花好人间(0.2%)、森(0.3%)、威尼斯狂欢(0.3%)、新品皮肤抽奖券*1(21.3%)</li>
<li>每一圈的5、6步【欧气到宝箱】——皮肤碎片*2(48.80%)荣耀积分*20(28.60%) 特工魅影(0.07%)缤纷独角兽(0.07%)晚萤(0.08%)白执事(0.08%)花好人间(0.2%)沉稳之力(0.2%)森(0.3%)威尼斯狂欢(0.3%)新品皮肤抽奖券*1(21.30%)</li>
<li>每一圈的第7步【终结孤单宝箱】——冠军飞将(0.05%)、圣诞恋歌(0.10%)、圣诞狂欢(0.10%)、战令币*10(16.85%）、皮肤碎片*2(31.95%)、荣耀积分*20(31.95%)、荣耀积分*10(19.00%)</li>
</ol>


<p style="margin-top:10px;">进阶地图活动宝箱中奖品概率公示：</p>     <ol>
<li>每一圈第1、2步【好运到宝箱】——皮肤碎片*5（48.80%）、荣耀积分*50(28.60%) 、云霓雀翎（0.30 %)、青蛇(0.40%)、敏锐之力(0.60%)、新品皮肤抽奖券*1(21.30%)</li>
<li>每一圈第3、4步【福气到宝箱】——皮肤碎片*5(48.80%)、荣耀积分*50(28.60%)、云霓雀翎(0.15%)、久胜战神(0.15%)、青蛇(0.2%)、猫狗日记-孙策(0.2%)、敏锐之力(0.3%)、掌控之力(0.3%)、新品皮肤抽奖券*1(21.3%)</li>
<li>每一圈的5、6步【欧气到宝箱】——皮肤碎片*5(48.80%)、荣耀积分*50(28.60%) 、云霓雀翎(0.1%)、久胜战神(0.1%)、黄金狮子座(0.1%)、青蛇(0.13%)、猫狗日记-孙策(0.13%)、 箭羽风息(0.13%)、 敏锐之力(0.31%)、掌控之力(0.3%)新品皮肤抽奖券*1(21.30%)</li>
<li>每一圈的第7步【终结孤单宝箱】——时之恋人-刘备(0.05%)、水晶猎龙者(0.10%)、曙光守护者(0.10%)、战令币*20(16.85%）、皮肤碎片*5(31.95%)、荣耀积分*40(31.95%)、荣耀积分*30(19.00%)</li>



  `,
  drawGroupid: {
    junior: [
      {
        rank: "1",
        groupid: "LUCK20201105000000",
        name: "好运到宝箱一"
      },
      {
        rank: "2",
        groupid: "LUCK20201105000001",
        name: "好运到宝箱二"
      },
      {
        rank: "3",
        groupid: "LUCK20201105000002",
        name: "福气到宝箱一"
      },
      {
        rank: "4",
        groupid: "LUCK20201105000003",
        name: "福气到宝箱二"
      },
      {
        rank: "5",
        groupid: "LUCK20201105000004",
        name: "欧气到宝箱一"
      },
      {
        rank: "6",
        groupid: "LUCK20201105000005",
        name: "欧气到宝箱二"
      },
      {
        rank: "7",
        groupid: "LUCK20201105000006",
        name: "终结孤单宝箱"
      }
    ],
    senior: [
      {
        rank: "1",
        groupid: "LUCK20201105000010",
        name: "好运到宝箱一"
      },
      {
        rank: "2",
        groupid: "LUCK20201105000011",
        name: "好运到宝箱二"
      },
      {
        rank: "3",
        groupid: "LUCK20201105000012",
        name: "福气到宝箱一"
      },
      {
        rank: "4",
        groupid: "LUCK20201105000013",
        name: "福气到宝箱二"
      },
      {
        rank: "5",
        groupid: "LUCK20201105000014",
        name: "欧气到宝箱一"
      },
      {
        rank: "6",
        groupid: "LUCK20201105000015",
        name: "欧气到宝箱二"
      },
      {
        rank: "7",
        groupid: "LUCK20201105000016",
        name: "终结孤单宝箱"
      }
    ]
  },
  service_zone: "https://pay.qq.com/h5/shop.shtml?pf=__mds_act_wzry&hash=%2Forder%2F2%2Fbiz%2F2%3FserviceZone%3D1",
  ads: [
    {
      img: "//midas.gtimg.cn/vmall/SH2019080715651597125986/2048eeadbda57588da941fca1d52a88b.jpg",
      url: "//v.qq.com"
    },

    {
      img: "//midas.gtimg.cn/vmall/SH2019080715651597125986/2048eeadbda57588da941fca1d52a88b.jpg",
      url: "//v.qq.com"
    }
  ],
  round: 100,
  tips: {
    noFreeChance: "您在当前参与活动的大区还没有完成【对战一局】任务，快去完成任务吧~",
    freeChance: "恭喜你获得一次免费抽奖资格，快去点击宝箱收获奖励吧~",
    selectChance: "去完成一轮对局即可获得免费走第一步的机会，<span style='font-weight: bold;'>直接支付将会失去本次免费机会</span>",
    selectChanceMiniTips: "",
    selectReceiveChance: "恭喜你获得免费开奖一次的机会",
    getChance: "对局一次，可免费走第一步，概率得史诗皮肤"
  },
  url: {
    game: "//pvp.qq.com/act/a20180824act/index.html"
  },
  maxPrizeListPageSize: 25,
  // 查询本次活动最吸引人的奖品列表
  bigPrizes: {
    junior: {
      text: "奖池一览",
      desc: "（详情查看更多）",
      prizeListImages: [
        "https://midas.gtimg.cn/cpay_config/16046519745453.png",
        "https://midas.gtimg.cn/cpay_config/16046520472092.png",
        "https://midas.gtimg.cn/cpay_config/16046485767190.png",
        "https://midas.gtimg.cn/cpay_config/16046520839473.png",
        "https://midas.gtimg.cn/cpay_config/16046493696152.png"
      ]
    },
    senior: {
      text: "奖池一览",
      desc: "（详情查看更多）",
      prizeListImages: [
        "https://midas.gtimg.cn/cpay_config/16046521627921.png",
        "https://midas.gtimg.cn/cpay_config/16046523877953.png",
        "https://midas.gtimg.cn/cpay_config/16046522343126.png",
        "https://midas.gtimg.cn/cpay_config/16046522646608.png",
        "https://midas.gtimg.cn/cpay_config/16046488738156.png"
      ]
    }
  }
}

export const GAME_INFO = window.__midasStaticConfig_wzry || info

export const REPORT = {
  PAGEVIEW: {
    // 页面曝光
    HOMEPAGE: "pageview.shop_activity_zjgd_homepage",
    //openlink登陆弹框
    LOGIN_PROMPT: "pageview.shop_activity_zjgd_login_prompt",
    //登陆失败
    LOGIN_ERROR: "pageview.shop_activity_zjgd_login_error",
    // 活动简介弹窗曝光
    INTRO: "pageview.shop_activity_zjgd_popup_introduction",
    // 弹窗曝光-切换大区角色
    ZONE_ROLE: "pageview.shop_activity_zjgd_popup_role",
    // 弹窗曝光-查看活动规则
    RULE: "pageview.shop_activity_zjgd_popup_rule",
    //排队弹框
    BUSY_DIALOG: "pageview.shop_activity_zjgd_busy_queue",
    //单领任务奖励失败
    RECEIVE_TASK_PRESENT_ERROR: "pageview.shop_activity_zjgd_task_present_error",
    //批量领任务奖励失败
    BATCH_RECEIVE_TASK_PRESENT_ERROR: "pageview.shop_activity_zjgd_get_all_task_present_error",
    //批量查抽奖券成功
    QUERY_BATCH_COUPON_SUCCESS: "pageview.shop_activity_zjgd_query_multi_coupon_succ",
    //批量查抽奖券异常
    QUERY_BATCH_COUPON_ERROR: "pageview.shop_activity_zjgd_query_multi_coupon_error",
    //连抽之前查6张券异常
    QUERY_BATCH_DRAW_COUPON_ERROR: "pageview.shop_activity_zjgd_query_6_coupon_error",
    //查到有未使用的抽奖券
    UNUSED_COUPON: "pageview.shop_activity_zjgd_unused_coupon",
    //抽奖成功
    LUCKY_DRAW_SUCCESS: "pageview.shop_activity_zjgd_draw_success",
    //抽奖异常
    LUCKY_DRAW_ERROR: "pageview.shop_activity_zjgd_draw_error",
    //下单异常
    PLACE_ORDER_ERROR: "pageview.shop_activity_zjgd_place_order_error",
    //支付成功
    PAY_SUCCESS: "pageview.shop_activity_zjgd_pay_success",
    //支付失败
    PAY_ERROR: "pageview.shop_activity_zjgd_pay_error",
    //查获得奖品
    GET_AWARD: "pageview.shop_activity_zjgd_show_award",
    //查看奖品列表成功,
    GET_AWARD_LIST: "pageview.shop_activity_zjgd_show_award_list",
    //获取openlink异常
    GET_OPENLINK_ERROR: "pageview.shop_activity_zjgd_get_open_link_error",
    //弹窗曝光-任务未完成去对局
    FREE_TASK_TODO: "pageview.shop_activity_zjgd_popup_taskgo",
    //弹窗曝光-任务已完成领券
    FREE_TASK_DONE: "pageview.shop_activity_zjgd_popup_taskdone",
    //弹窗曝光-选择对战或支付
    SELECT_TASK_OR_PAY: "pageview.shop_activity_zjgd_battle",
    //查用户是否对战失败
    CHECK_BATTLE_ERROR: "pageview.shop_activity_zjgd_popup_check_battle_error",
    // 对战后参与任务+1失败
    JOIN_FREE_TASK_ERROR: "pageview.shop_activity_zjgd_popup_join_free_task_error",
    // 查询奖池成功
    GET_PRIZE_LIST_SUCCESS: "pageview.shop_activity_zjgd_get_prizelist_success",
    // 查询奖池失败
    GET_PRIZE_LIST_ERROR: "pageview.shop_activity_zjgd_get_prizelist_error"
  },
  CLICK: {
    // 点击-购买1步
    BUY_PRODUCT_20: "click.shop_activity_zjgd_chance20",
    // 点击-购买6步（直通终点）
    BUY_PRODUCT_114: "click.shop_activity_zjgd_chance114",
    BUY_PRODUCT_50: "click.shop_activity_zjgd_chance50",
    BUY_PRODUCT_285: "click.shop_activity_zjgd_chance285",
    SELECT_BUY_PRODUCT_20: "click.shop_activity_zjgd_gotopay_chance20",
    SELECT_BUY_PRODUCT_114: "click.shop_activity_zjgd_gotopay_chance114",
    // 点击-宝箱图标
    BOXES: "click.shop_activity_zjgd_gift",
    SWITCH_MAP: "click.shop_activity_switch_map",
    // 点击-去获得免费抽奖机会
    GET_FREE_TASK: "click.shop_activity_zjgd_goforfree",
    // 点击-去对局
    GO_BATTLE: "click.shop_activity_zjgd_battle",
    // 点击-去抽奖（已领券）
    RECEIVE_TASK_GO_LOTTERY: "click.shop_activity_zjgd_getfree",
    // 点击分享
    SHARE: "click.shop_activity_zjgd_share",
    // 点击重试
    RETRY_PRIZE_LIST: "click.shop_activity_zjgd_get_prizelist_retry",
    // 点击now直播
    nowClick: "click.shop_activity_zjgd_now_click",
    // 购买点券二次确认按钮
    CONFIRM_PAY: "click.shop_activity_zjgd_confirm_pay",
    // 对战弹窗去获取-点击(去对战)
    SELECT_GOBATTLE: "click.shop_activity_zjgd_gotobattle",
    // 对战弹窗去获取-点击(领取成功)
    SELECT_BATTLED: "click.shop_activity_zjgd_battled",
    // 对战弹窗去获取-点击(领取成功后新弹窗里的去开宝箱)
    SELECT_GOLOTTERY: "click.shop_activity_zjgd_gotolottery"
  }
}

export const MAP = {
  JUNIOR: "junior",
  SENIOR: "senior"
}
